module.exports = __webpack_public_path__ + "static/media/Gyftmasters_362_362.9c7de140.png";